import {Controller} from "@hotwired/stimulus"

/**
 * DestroyController allows to remove an element from a collection. If
 * the element's id is filled in, the record is marked for destruction via
 * a (hidden) input. If the ID is empty, the element is removed immediately.
 *
 *  %li{data: { controller: 'destroy' }}
 *    %input{type: :hidden, data: { destroy_target: :id}, value: '42'}
 *    %input{type: :hidden, value: '0', data: { destroy_target: :destruction}}
 *    %button{data: { action: 'click->destroy#destroy' }}
 *      Remove
 */
export default class extends Controller {
  static targets = ['id', 'destruction']

  destroy(event) {
    const warning = event.currentTarget.dataset.confirmationWarning
    if (warning && !confirm(warning)) return

    if (this.idTarget.value) {
      this._markForDestruction()
      this._hide()
    } else {
      this._remove()
    }
  }

  _markForDestruction() {
    this.destructionTarget.value = '1'
  }

  _hide() {
    this.element.style.display = 'none'
  }

  _remove() {
    this.element.remove()
  }
}
